/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const servicedeskKnowledgeBaseAiDraftGenerateResource: RouteResource<any> = createResource({
	type: 'SERVICEDESK_KNOWLEDGE_BASE_AI_DRAFT_GENERATE',
	getKey: ({ match }) => match.params.projectKey || '',
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-knowledge-base-ai-draft-generate", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-ai-draft-generate" */ './fetchAiDraftGenerate.tsx'
		),
	maxAge: Infinity,
	isBrowserOnly: true,
});
